import { Component, OnInit } from '@angular/core';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { GridOptions, GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { RequestTypeModalComponent } from './request-type-modal/request-type-modal.component';
import { DateObject, GM_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { ColumnsSelectionPopupComponent, UserPreferenceColumns, UserPreferenceColumnsList } from 'src/app/common/columns-selection-popup/columns-selection-popup.component';

@Component({
  selector: 'app-grants-applications',
  templateUrl: './grants-applications.component.html',
  styleUrls: ['./grants-applications.component.scss']
})
export class GrantsApplicationsComponent implements OnInit {
  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  alloperations;
  rowData;
  advanceSearch;
  selectedRow;
  caseDetails
  grantsapp: GM_APP;
  grants: GM_APP[];
  menudata: ModuleMenu;
  grantsForm: UntypedFormGroup;
  therapeuticAreas: any;
  GrantTypeList: Array<any> = [];
  IsOnlyGrandType: boolean = false; 
  subGetData: SubscriptionLike;
  TheraputicAreaList: any;
  ApplicationTypeList: any[];
  StatusList: any;
  columns:any;
  istAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '2', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  istMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '2', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  grantsAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '4', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  grantsMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '4', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  eapAlluserPreferenceColumns: UserPreferenceColumns = { ModuleID: '5', IsAllApplications: true, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  eapMyuserPreferenceColumns: UserPreferenceColumns = { ModuleID: '5', IsAllApplications: false, THERAPEUTIC_AREA_ID: true, STUDY_TYPE: true, PRODUCTIDS: true, SUBMITTED_ON: true, LAST_UPDATED_ON: true };
  userPreferenceColumnsLst: UserPreferenceColumnsList = { IstAllApplications: this.istAlluserPreferenceColumns, IstMyApplications: this.istMyuserPreferenceColumns, GrantsAllApplications: this.grantsAlluserPreferenceColumns, GrantsMyApplications: this.grantsMyuserPreferenceColumns,EapAllApplications: this.eapAlluserPreferenceColumns, EapMyApplications: this.eapMyuserPreferenceColumns };
  ApplicationID:string = '';
  ApplicationType:string = '';
  GrantType:string = '';
  PhysicianName:string = '';
  TherapeuticArea:string = 'Therapeutic area';
  RequestType:string = '';
  Product:string = '';
  StudyType:string = '';
  Owner:string = '';
  Status:string = '';
  maxDate = new Date() ; 
  isHadPermission: boolean = false;

  constructor(
    private router: Router,
    public routerr: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private header: HeadService,
    public apiService: ApidataRequestService,
    private grantsDataShare:GrantsDatashareService
  ) {

  }

  ngOnInit() {
    //this.StatusList= [{ "value": "", "label": "All" },{ "value": "1", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Rejected" }, { "value": "7", "label": "On-hold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discarded" }];
    this.columns = this.routerr.snapshot.data["items"][0];
    if(this.routerr.snapshot.data["items"][1] != null){
      this.userPreferenceColumnsLst = this.routerr.snapshot.data["items"][1];
    } 
    this.collapesedOrNot = false;
    this.setDefaultData();

    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      ApplicationType: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("A")
    });
    let chnageWonership = this.commonService.getScreenPermission("401","C");
     let hadeditPermission = this.commonService.getScreenPermission("401","E");
     if(chnageWonership || hadeditPermission)
     {
       this.isHadPermission=true;
     }
    var formData = this.grantsForm.value;
    this.setSearchSummary(formData);
    this.GetMasterData();
    this.getApplicationtypes();
  }

  submitfromDate(event){
    this.grantsForm.get('DATETO')?.setValue(null);
    this.Submit_from_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 0,
      Minutes : 0,
      Seconds : 0,
      HasValue : true

    };
  }
  submitendDate(event){
    this.Submit_end_date = {
      Day : event.getDate(),
      Month : event.getMonth()+1,
      Year : event.getFullYear(),
      Hours : 23,
      Minutes : 59,
      Seconds : 59,
      HasValue : true

    }

  }

  Submit_from_date : DateObject;
Submit_end_date : DateObject;

  setSearchSummary(formData) {
    if (formData["DATEFROM"] != null && formData["DATEFROM"] != undefined && formData["DATEFROM"] != 'Invalid Date') 
    {
      //formData["StartDate"] = new Date(formData["StartDate"]);
      formData["DATEFROMOBJ"] = this.Submit_from_date; 
    }
    if (formData["DATETO"] != null && formData["DATETO"] != undefined && formData["DATETO"] != 'Invalid Date') {
      
     // formData["EndDate"] = new Date(formData["EndDate"]);
      formData["DATETOOBJ"] = this.Submit_end_date;
    }

    this.summaryService.getGrantAppAdvSearch("api/gmapp/getadvsearch", formData).subscribe(data => {
      this.grants = data;
    });
  }

  GetTherapeuticAreas() {
    this.summaryService.getData("api/gmapp/gettherapeuticarealist").subscribe((result) => {
      if (result != null) {
        this.TheraputicAreaList = result;
        this.TheraputicAreaList=  [{label:"Select",value:"-1", checked: true}].concat(this.TheraputicAreaList);

      }
    });
  }

  getApplicationtypes() {
    let submodule = "-1";
    let moduleID = "4";
    this.commonService.getAllApplicationTypesforSearch(moduleID, submodule).subscribe((result) => {
      if (result) {
        this.ApplicationTypeList = result;
      }
    });
  }

  GetStatusList() {
    this.summaryService.getData("api/gmapp/getstatus/4").subscribe(result => {
      if (result != null) {
        this.StatusList = result;
        this.StatusList=  [{label:"Select",value:"-1", checked: true}, { label: "Returned", value: "Returned", checked: true }].concat(this.StatusList);

      }
    });
  }

  GetOrgGrantTypes() {
    this.GrantTypeList=[];
    this.subGetData = this.summaryService.getData("api/common/GetOrgGrantTypesForSearch").subscribe(
      (res) => {
        this.GrantTypeList=res["Data"];
      }
    );
  }
  GetMasterData() {
    this.GetTherapeuticAreas();
    this.GetOrgGrantTypes();
    this.GetStatusList();
  }

  setDefaultData() {
    this.setUserPreferenceColumns();
    this.caseDetails = [
      {
        "caseSet": {
          "caseHeading": "",
          "caseData": [
            {
              "label": "Organization Name ",
              "value": "OrgName"
            },
            {
              "label": "Tax Status",
              "value": "TaxStatus"
            },
            {
              "label": "Tax ID",
              "value": "TaxID"
            },
            {
              "label": "Application ID",
              "value": "APPLICATION_CODE"
            },
            {
              "label": "Raised By",
              "value": "CreatedStr"
            },
            {
              "label": "Email ID",
              "value": "EMail"
            },
            {
              "label": "Grant Type",
              "value": "GRANTTYPE"
            },
            {
              "label": "TherapeuticArea",
              "value": "TherapeuticArea"
            },
            {
              "label": "Status",
              "value": "StatuStr"
            },
            {
              "label": "Requested Budget",
              "value": "REQUESTED_AMOUNT"
            },
            {
              "label": "Approved Budget",
              "value": "ALLOCATION_AMOUNT"
            },
            {
              "label": "Authorized Signer",
              "value": "AUTH_SIGNER"
            }
          ]

        }
      }];
      this.advanceSearch = {
        "fields": [
          {
            "label": "Application ID",
            "field": "ApplicationID",
            "type": "text"
          },
          {
            "label": "Grant Type",
            "field": "Grant_type",
            "type": "dropdown"
          },
          {
            "label": "Therapeutic Area",
            "field": "TherapeuticArea",
            "type": "dropdown",
            "options":this.TheraputicAreaList,
          },
          {
            "label": "Status",
            "field": "STATUS",
            "type": "dropdown"
          },
          {
            "label": "Submitted From Date",
            "field": "DATEFROM",
            "type": "date"
          },
          {
            "label": "Submitted To Date",
            "field": "DATETO",
            "type": "date"
          }
        ],
        "filters": []
      }
   
    this.alloperations = [
      //{
      //  "name": "On Hold",
      //  "id": "onHold"
      //},
      //{
      //  "name": "Release",
      //  "id": "release"
      //},
      //{
      //  "name": "Route",
      //  "id": "route"
      //},
      //{
      //  "name": "Return",
      //  "id": "return"
      //},
      //{
      //  "name": "Withdraw",
      //  "id": "withdraw"
      //},
      //{
      //  "name": "Discard",
      //  "id": "discard"
      //},
      //{
      //  "name": "New Application",
      //  "id": "add"
      //}
    ];

    this.operations = this.alloperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    this.commonService.removeLeftMenu();
    this.commonService.appId=event.data["APPLICATION_ID"];
      this.commonService.refreshApplicationPage(event.data["APPLICATION_ID"], "grants","","all");
  }

  add() {
    this['self'].modalRef = this['self'].modalService.show(RequestTypeModalComponent, {
      backdrop: false,
      keyboard: false,
      ignoreBackdropClick: true,
      class:'modal-vlg modal-full-height modal-right',
      animated: true,
      data: {
        id: this["self"].selectedRow['application_id']
      }
    });
  }

  edit() {
    this["self"].router.navigate(['/home/grants/my-applications/application-ext/:'+ this["self"].selectedRow['application_id']+'/general_information'], {skipLocationChange:true, queryParams:{module:"grants", id:this['self'].selectedRow['id'], app_ext:true, screen_type:"applications"}})
  }


 

  setSearch() {
    this.SearchClear();
    this.setSearchSummary(this.grantsForm.value);
  }

  //// Advace search Functions
  SearchClear() {
    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      ApplicationType: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("A")
    });
    //  this.setSummary();
  }

  AdvanceSearch() {
    this.setSearchSummary(this.grantsForm.value);
  }

  getTherapeuticAreas() {
    this.summaryService.getTherapeuticAreaList(null).subscribe((result) => {
      if (result != null) {
        this.therapeuticAreas = result;
      }
    });
  }

  // getColumns(){
  //   this.commonService.GetColumns('4',true).subscribe({
  //     next:(res)=>{
  //       if(res){
  //         this.columns= res;
  //       }
  //     }
  //   }
  //   )
  // }

  setUserPreferenceColumns(){
    this.columnDefs = [];
    this.columns.forEach(x=>{
      if(x.FieldCode == 'APPLICATION_ID'){
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "APPLICATION_CODE"
          }
        );
      }
      if(x.FieldCode == 'APPLICATION_TYPE'){
        this.ApplicationType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName":  x.ColumnName,
            "field": "APPLICATION_TYPE_NAME"
          },
        );
      }
      if(x.FieldCode == 'PHYSICIAN_NAME'){
        this.PhysicianName = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "PhysicianName"
          }
        );
      }
      if(x.FieldCode == 'REQUEST_TYPE'){
        this.RequestType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "REQUEST_TYPE_NAME"
          }
        );
      }
      if(x.FieldCode == 'GRANT_TYPE'){
        this.GrantType = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "GRANTTYPE"
          }
        );
      }
      if(x.FieldCode == 'RAISED_BY'){
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "CreatedStr"
          }
        );
      }
      if(x.FieldCode == 'OWNER'){
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "AssignedStr"
          }
        );
      }
      if(x.FieldCode == 'STATUS'){
        this.Status = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "StatuStr"
          }
        );
      }

      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsAllApplications) {
        if (x.FieldCode == 'THERAPEUTIC_AREA_ID') {
          this.TherapeuticArea = x.ColumnName;
          if (this.userPreferenceColumnsLst.GrantsAllApplications.THERAPEUTIC_AREA_ID) {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "THERAPEUTIC_AREA_NAME"
              }
            );
          }
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsAllApplications) {
        if (this.userPreferenceColumnsLst.GrantsAllApplications.PRODUCTIDS && x.FieldCode == 'PRODUCTIDS') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "PRODUCT_NAME"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsAllApplications) {
        if (this.userPreferenceColumnsLst.GrantsAllApplications.STUDY_TYPE && x.FieldCode == 'STUDY_TYPE') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "StudyType"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsAllApplications) {
        if (this.userPreferenceColumnsLst.GrantsAllApplications.SUBMITTED_ON && x.FieldCode == 'SUBMITTED_ON') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "SubmittedOnStr"
            },
          );
        }
      }
      if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.GrantsAllApplications) {
        if (this.userPreferenceColumnsLst.GrantsAllApplications.LAST_UPDATED_ON && x.FieldCode == 'LAST_UPDATED_ON') {
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "UpdateDateStr"
            }
          );
        }
      }
    })
    setTimeout(()=>{
      this.gridApi.refreshHeader();
      this.gridApi.sizeColumnsToFit();
      },500);
  }

  getUserPreferenceColumns(){
    this.commonService.GetUserPreferencesColumns().subscribe({
      next:res=>{
        if(res){
          this.userPreferenceColumnsLst = res;
        }
          this.setUserPreferenceColumns();
      }
    })
  }

  selectColumns($event){
    let modalRef = this.modalService.open(ColumnsSelectionPopupComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = { columns: this.columns,moduleId:"4",isAllApplications: true};
    modalRef.result.then((result) => {
      this.getUserPreferenceColumns();
    });
  }

}
